import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = [
    "formContainer",
    "message",
    "category",
    "requestType",
    "recipientSelector",
    "recipients",
    "messageError",
    "categoryError"
  ]

  connect() {
    this.boundHideCategoryError = this.hideCategoryError.bind(this)
    this.initCategory()
    this.initRecipients()
  }

  disconnect() {
    if (this.categoryTarget) {
      this.categoryTarget.removeEventListener('change', this.boundHideCategoryError)
    }
    if (this.categoryChoices) this.categoryChoices.destroy()
    if (this.recipientsChoices) this.recipientsChoices.destroy()
  }

  showForm(event) {
    event.preventDefault()
    this.formContainerTarget.classList.remove("is-hidden")
    this.formContainerTarget.classList.add("animate__animated", "animate__fadeIn")
  }

  hideForm(event) {
    event.preventDefault()
    this.formContainerTarget.classList.add("is-hidden")
    this.formContainerTarget.classList.remove("animate__animated", "animate__fadeIn")
  }

  toggleRecipients() {
    const selectedType = this.requestTypeTargets.find(radio => radio.checked).value

    if (selectedType === 'targeted') {
      this.recipientSelectorTarget.classList.remove("is-hidden")
    } else {
      this.recipientSelectorTarget.classList.add("is-hidden")
    }
  }

  validateForm(event) {
    const hasCategory = this.categoryTarget.value !== ''

    let isValid = true

    if (!hasCategory) {
      event.preventDefault()
      this.showCategoryError()
      isValid = false
    }

    return isValid
  }

  showMessageError() {
    this.messageErrorTarget.classList.remove("is-hidden")
  }

  hideMessageError() {
    this.messageErrorTarget.classList.add("is-hidden")
  }

  showCategoryError() {
    this.categoryErrorTarget.classList.remove("is-hidden")
  }

  hideCategoryError() {
    this.categoryErrorTarget.classList.add("is-hidden")
  }

  initCategory() {
    fetch("/categories.json")
      .then(response => response.json())
      .then(data => {
        this.setupCategory(data)
      })
      .catch(error => {
        console.error('Error fetching categories:', error)
      })
  }

  setupCategory(categories) {
    this.categoryChoices = new Choices(this.categoryTarget, {
      choices: categories,
      searchFields: ['label']
    })

    this.categoryTarget.addEventListener('change', this.boundHideCategoryError)
  }

  initRecipients() {
    fetch("/friends.json")
      .then(response => response.json())
      .then(data => {
        this.setupRecipients(data)
      })
      .catch(error => {
        console.error('Error fetching friends:', error)
      })
  }

  setupRecipients(data) {
    const friends = data.friends || data // Handle both old and new response formats
    this.recipientsChoices = new Choices(this.recipientsTarget, {
      choices: friends,
      searchFields: ['label'],
      removeItemButton: true
    })
  }
}
